export default {
  globals: {
    insufficientPermissions: 'You do not have sufficient permissions to perform this action',
    notUTF8Encoded: 'Bad Codification',
    language: 'Language',
    activated: 'Activated',
    notAValidSerial: 'Not a valid Serial',
    confirmDeleteTitle: 'This action in not reversible',
    confirmDeleteText: 'Do you want to delete the elements?',
    confirmExitTitle: 'There are unsaved changes',
    confirmResetTitle: 'This action in not reversible',
    confirmResetText: 'If you reset, you will loose every change to the grid',
    confirmExitText: 'Do you want to exit without saving changes?',
    confirmInvalidateText: 'Do you want to invalidate the request?',
    notEnoughPermissions: 'You do not have sufficient permissions to enter this module',
    languageNotSupported: 'The language you are trying to use its not supported for the moment.\n If you wish a personalized translation contact support',
    notEnoughPermissionsRes: 'You do not have sufficient permissions to access this resource',
    notBought: 'You don\'t have this module in your contract, contact <a href="mailto:info@foodeo.es" style="color: blue">info@foodeo.es</a> for more information',
    mustAddProducts: 'Must add Products',
    localRequestsMustHaveTable: 'Local request must have an assigned table',
    domicilePickUpRequestsMustHaveClient: 'Domicile/PickUp requests must have an assigned client',
    domicilePickUpRequestsMustHaveShiftTime: 'Domicile/PickUp requests must have an assigned shift',
    domicileRequestsMustHaveAddress: 'Domicile requests must have an address assigned',
    closeAllIfContinue: 'All your requests will be closed if you continue',
    notFound: 'You are trying to access a non existing route, please navigate with the sidebar',
    subdomainNotFound: 'Oops! It seems that something has gone wrong, the address you are looking for is not correct. Please try again or contact your administrator',
    loseAllIfContinue: 'All your changes will be lost if you continue',
    loseAllIfClose: 'All your changes will be lost if you close',
    noResults: 'No results',
    areYouSure: 'Are You Sure?',
    yes: 'Yes',
    no: 'No',
    search: 'Search',
    of: 'of',
    image: 'Image',
    actions: 'Actions',
    noElements: 'No elements',
    noElement: 'No element',
    translations: 'Translations',
    required: 'Required',
    onlyMoreThanZero: 'Only numbers greater than zero',
    noNegative: 'Only positive numbers',
    dontAllowMaximize: 'Your browser does not allow to maximize',
    multiSelection: 'Multiple Selection',
    printing: 'Printing Ticket',
    mustConfigureRequestType: 'You must configure this request type',
    insertingElement: 'Inserting Element...',
    editingElement: 'Editing Element...',
    payingElement: 'Paying Element...',
    exit: 'Exit',
    currency: 'Currency',
    nonAbleToSplitByProducts: 'You can not split by products if you have a global discount applied',
    nonAbleToDiscountToProduct: 'You cannot apply a numeric discount to a single product, apply it to the whole order instead.',
    months: {
      january: 'January',
      february: 'February',
      march: 'March',
      april: 'April',
      may: 'May',
      june: 'June',
      july: 'July',
      august: 'August',
      september: 'September',
      october: 'October',
      november: 'November',
      december: 'December',
    },
    weekDays: {
      sunday: 'Sunday',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
    },
    dates: {
      today: 'Today',
      yesterday: 'Yesterday',
      lastSeven: 'Last 7 Days',
      lastThirty: 'Last 30 Days',
      firstTrim: 'First Trimester',
      secondTrim: 'Second Trimester',
      thirdTrim: 'Third Trimester',
      fourthTrim: 'Fourth Trimester',
      currentMonth: 'Current Month',
      lastMonth: 'Last Month',
      allYear: 'All Year',
      last3Month: 'Last 3 Month'
    },
    unitTypes: {quantity: 'Unitary Quantity', volume: 'Volume', weight: 'Weight'},
    logoSizeValidateMessage: 'Image size must be less than 100 kb',
    headerImageSizeValidateMessage: 'Header image size must be less than 1000 kb',
    kioskHeaderImageSizeValidateMessage: 'Header image size must be less than 5 MB',
    measures: {
      ml: 'Milliliter',
      cl: 'Centiliter',
      dl: 'Deciliter',
      L: 'Liter',
      g: 'Gram',
      kg: 'Kilogram',
      oz: 'Ounce',
      lb: 'Pound',
      ud: 'Unit',
    },
    selectUser: 'Select User',
    moreFilters: 'More Filters',
    noObservations: 'No observations',
    loading: 'Loading...',
    confirmDuplicateTitle: 'Duplicate product',
    confirmDuplicateText: 'Are you sure you want to duplicate the product',
    confirmUpdateCategoryTitle: 'Update category',
    confirmUpdateCategoryText: 'Select new category',
    confirmDeleteBody: 'Are you sure you want to remove',
    confirmDeleteproductsText: 'the selected products?',
    confirmDeletecategoriesText: 'the selected categories?',
    confirmDeleteawardsText: 'the selected awards?',
    confirmDeleteemployeesText: 'the selected employees?',
    confirmDeleteclientsText: 'the selected clients?',
    confirmDeletetablesText: 'the selected tables?',
    confirmDeletezonesText: 'the selected zones?',
    confirmDeletescreensText: 'the selected screens?',
    confirmDeleteprintersText: 'the selected printers?',
    confirmDeletefamiliesText: 'the selected families?',
    confirmDeleteshiftsText: 'the selected shifts?',
    confirmDeleteoptionsText: 'the selected options?',
    confirmDeletemodifiersText: 'the selected modifiers?',
    'confirmDeletebooking-optionsText': 'the selected options?',
    confirmDeletestockText: 'the selected Warehouse?',
    confirmDeleteproviderText: 'the selected provider?',
    confirmDeleteingredientsText: 'the selected ingredients?',
    confirmDeletereportsText: 'the selected report?',
    confirmDeleteunitsText: 'the selected unit?',
    confirmDeleteoffersText: 'the selected offers?',
    confirmDeleteZoneText: 'the selected zone?',
    resetPasswordText: 'Enter the email with which you registered and we will send you the new password by email, check your email spam folder just in case.',
    forgotPassword: 'Forgot your password?',
    resetPasswordSent: 'The password has been sent to the requested email correctly.',
    userNotFound: 'User not Found',
    localDisabled: 'Local disabled, please contact support',
    maintenanceMode: 'Maintenance mode',
  },
  types: {
    toBarAdd: 'Insert',
    add: 'Insert',
    edit: 'Edit',
    readOnly: 'Read-Only',
    save: 'Save',
    duplicate: 'Duplicate'
  },
  actions: {
    select: 'Select',
    reset: 'Reset',
    markAll: 'Mark all',
    return: 'Return',
    accept: 'Accept',
    clean: 'Clean',
    send: 'Send',
    cancel: 'Cancel',
    continue: 'Continue',
    close: 'Close',
    edit: 'Edit',
    details: 'Details',
    delete: 'Delete',
    deleteSelected: 'Delete Selected',
    insert: 'Insert',
    recharge: 'Recharge',
    search: 'Search',
    selected: 'Selected',
    save: 'Save',
    closeWithoutSaving: 'Close without saving',
    print: 'Print',
    invalidate: 'Invalidate',
    invite: 'Invite',
    createInvoice: 'Invoice',
    add: 'Add',
    apply: 'Apply',
    restore: 'Restore',
    new: 'New',
    reject: 'REJECT',
    exit: 'Exit',
    exitAndSave: 'Exit and Save',
    goBack: 'Go Back',
    editMap: 'Grid',
    login: 'Login',
    closeAll: 'Close All',
    retry: 'Try again',
    selectOrInsert: 'Select Or Insert A Table',
    preview: 'Preview',
    duplicate: 'Duplicate',
    update: 'Update'
  },
  modules: {
    'product': 'Product',
    'products': 'Products',
    'tables': 'Tables',
    'table': 'Table',
    'screens': 'Screens',
    'screen': 'Screen',
    'zone': 'Zone',
    'zones': 'Zones',
    'user': 'User',
    'users': 'Users',
    'printer': 'Printer',
    'printers': 'Printers',
    'client': 'Client',
    'clients': 'Clients',
    'request': 'Request',
    'requests': 'Requests',
    'cashRegister': 'Cash Register',
    'box_report': 'Box Report',
    'calendar': 'Calendar',
    'reports': 'Reports',
    'stocks': 'Stocks',
    'stock': 'Stock',
    'settings': 'Settings',
    'booking-options': 'Options',
    'bookings': 'Bookings',
    'shifts': 'Shifts',
    'shift': 'Shift',
    'category': 'Category',
    'categories': 'Categories',
    'employee': 'Employee',
    'employees': 'Employees',
    'distribution': 'Distribution',
    'tableMap': 'Table map',
    'awards': 'Awards',
    'ingredient': 'Ingredient',
    'ingredients': 'Ingredients',
    'provider': 'Provider',
    'providers': 'Providers',
    'purchase': 'Purchase',
    'purchases': 'Purchases',
    'tpv': 'TPV',
    'family': 'Family',
    'families': 'Families',
    'stockReport': 'Stock',
    'stock_report': 'Stock',
    'card': 'Menu',
    'cashiers': 'Cashiers',
    'cashier': 'Cashier',
    'modifiers': 'Modifiers',
    'modifier': 'Modifier',
    'option': 'Option',
    'options': 'Options',
    'addresses': 'Addresses',
    'address': 'Address',
    'recipes': 'Recipes',
    'recipe': 'Recipe',
    'TPV': 'POS',
    'purchaseOrders': 'Orders',
    'purchaseOrder': 'Order',
    'unit': 'Unit',
    'units': 'Units',
    'offers': 'Offers',
    'loyalty': 'Loyalty',
    'timeTracking': 'Time Tracking',
  },
  address: {
    major: 'Major',
    markAsDefault: 'Select as default',
    active: 'Active',
    noDirections: 'No Directions',
    reference: 'Reference',
    needPrincipal: 'Must select a default address',
    cantNoDeletePrincipalAddress: 'You cannot delete the primary address',
  },
  auth: {
    email: 'Email',
    password: 'Password',
    selectTPV: 'Select TPV',
  },
  product: {
    name: 'Name',
    category: 'Category',
    serial: 'Serial No.',
    image: 'Image',
    price: 'Price',
    purchasePrice: 'Purchase Price',
    description: 'Description',
    allergen: 'Allergen',
    noProducts: 'No products',
    combined: 'Combined',
    aggregated: 'Aggregated',
    unitType: 'Unit Type',
    unit: 'Measurement Unit',
    measures: 'Measures',
    amountOf: 'Amount of',
    minStock: 'Minimum amount to alert',
    minMessage: 'Will never notify if left empty',
    orderGroup: 'Group',
    orderGroupTypes: {
      incoming: 'Incoming',
      first_plate: 'First Plate',
      second_plate: 'Second Plate',
      desserts: 'Dessert',
      no_group: 'No order',
    },
    applyPriceByZones: 'Apply different price by zone',
    qty_existence: 'Quantity in stock',
    order: 'Order',
    hasModifiers: 'Has Modifiers',
    cantSubstractPayed: 'Cant Substract payed products',
    cantSubstractPrice: 'The total price cannot be less than what was paid',
  },
  offer: {
    name: 'Name',
    code: 'Code',
    discount: 'Discount',
    discountType: 'Discount Type',
    start: 'Start',
    end: 'End',
    noOffers: 'No Offers',
    description: 'Description',
    from: 'From',
    to: 'To',
    range: 'Range',
    validity: 'Validity',
    requiredName: 'Name is required',
    requiredDate: 'Date is required',
    datesNotCorrect: 'The final date cannot be earlier than the start date',
    hour: 'Hour',
    validate: 'Validate',
    validateOffer: 'Validate Offer',
    invalidCode: 'Invalid code',
    apply: 'Apply',
    offer: 'Offer',
    totalLimit: 'Maximum limit',
    clientLimit: 'Client limit',
    incorrectLimits: 'Wrong limits',
    wrongPrice: 'Wrong Value',
    cannotUseCode: 'Can\'t use that code',
    codeRequired: 'Required code',
  },
  ingredient: {
    name: 'Name',
    serial: 'Serial No.',
    image: 'Image',
    price: 'Unit Price',
    purchasePrice: 'Purchase price',
    description: 'Description',
    noIngredients: 'No ingredients',
    unitType: 'Unit Type',
    unit: 'Measurement Unit',
    amountOf: 'Amount of',
    oldPrice: 'Previous price',
    tendency: 'Tendency',
    sku: 'SKU Code',
  },
  category: {
    noCategories: 'No Categories',
    noCategoriesCreated: 'There are no categories created',
    companion: 'Companion',
    aggregated: 'Aggregated',
    children: 'Children',
    name: 'Name',
    image: 'Image',
    appText: 'App Text',
    subCategory: 'Subcategory',
    hasSubcategories: 'Has Subcategories',
    hasSubcategoriesInfo: 'This option allows you to add one or more subcategories to this category. As an example, Drinks category could have as subcategories Soft-Drink and Wines categories, this a way to group them for the App',
    hasCompanion: 'Has Companion',
    hasCompanionInfo: 'This option allows you to add a companion to the category. As an example, Drinks category could have Soft-Drinks as companion, this way you can only select one soft drink to your drink',
    hasAggregated: 'Has Aggregated',
    hasAggregatedInfo: 'This option allows you to add one or more aggregated to the category. As an example, Pizzas category could have Ingredients category as an aggregated, this way you can add extras to the category',
    activatedInfo: 'This option allows you to activate/deactivate categories, if a category is deactivated it will not be shown on "Insert Request" dialog',
    available: 'Available',
    availableInfo: 'If this option is deactivated, whenever an user makes a request, a message will be shown pointing that this category cannot be used right now. This can be used if you have your kitchen full and want to pause requests',
    clientActivated: 'Client Activated',
    clientActivatedInfo: 'This option allows you to activate/deactivate categories for clients, if this option is deactivated, this category will not be shown to the clients on the menu',
    order: 'Order',
    showCategoryName: 'Show category name',
    maxAggregates: 'Max aggregates',
  },
  family: {name: 'Name', categories: 'Categories', printers: 'Printers', noFamilies: 'No Families'},
  table: {
    noTables: 'No tables',
    name: 'Name',
    tableName: 'Table Name',
    qr: 'QR',
    changeTable: 'Change table',
    fusionTable: 'Fusion table',
    sameTableValidation: 'Cannot select the same table',
    emptyFieldsErrorMsg: 'There are %{field} field/fields empty.',
    fusionTableAlert: 'If you continue, you will lose any discounts and partial payments that the table may have. do you wish to continue?',
    newTable: '+ New Table',
    deleteTable: 'Delete Table',
    confirmChange: 'Are you sure you want to change the command to another table?',
    order: 'App Order',
  },
  cashier: {
    noCashiers: 'No Cashiers',
    name: 'Name',
    printer: 'Printer',
    pulse: 'Pulse',
    port: 'Port',
  },
  screen: {
    noScreens: 'No Screens',
    name: 'Name',
    categories: 'Categories',
    tpv: 'TPV',
    showVarious: 'Show various products',
  },
  provider: {
    noProviders: 'No Providers',
    name: 'Name',
    phone: 'Phone',
    email: 'Email',
    category: 'Category',
    description: 'Description',
  },
  award: {
    noAwards: 'No awards',
    name: 'Name',
    image: 'Image',
    coins: 'Coins',
  },
  zone: {
    noZone: 'No Zones',
    name: 'Name',
    nameZone: 'Zone Name',
    selectTPV: 'Select TPV',
    mainTPV: 'Select Main TPV',
    secondaryTPV: 'Select Secondary TPV',
    withoutAssign: 'Without Assign',
    mainPrinter: 'Main Printer',
    validateTablesCount: 'You cannot add more than',
    tables: 'tables',
    deleteZone: 'Delete Zone',
    newZone: '+ New Zone'
  },
  role: {
    name: 'Name',
    description: 'Description',
  },
  user: {
    noUsers: 'No Users',
    firstName: 'Name',
    lastName: 'Last Name',
    email: 'E-Mail',
    role: 'Role',
    phone: 'Phone Number',
    phN: 'Phone',
    mustBeValidEmail: 'Must be a valid email address',
    address: 'Address',
    pass: 'Password',
    passConfirm: 'Password Confirmation',
    unmatchedPass: 'Unmatched Passwords',
    permissions: 'Permissions',
  },
  client: {
    noClients: 'No Clients',
    firstName: 'Name',
    lastName: 'Last Name',
    username: 'User Name',
    email: 'E-Mail',
    phone: 'Phone Number',
    city: 'Province',
    town: 'Town',
    address: 'Address',
    fiscalName: 'Fiscal Name',
    fiscalAddress: 'Fiscal Address',
    postalCode: 'Postal Code',
    dniCif: 'DNI/CIF',
    searchClient: 'Search Client',
    newClient: '+New Client',
    street: 'Street',
    streetNumber: 'Street Number',
    floorAndDoor: 'Floor and Door',
    clientNotFound: 'Client not found',
    communications: "Communications",
  },
  recipe: {
    price: 'Price',
    platePrice: 'Plate price',
    benefit: 'Benefit',
    margin: 'Margin',
    info: 'Markup refers to the additional percentage that is added to the cost of products or services to determine their selling price to the customer. It is a key measure for calculating the profitability of a business in the hospitality industry. It is recommended that the minimum margin in hospitality should be at least 300%.',
  },
  purchase: {
    noPurchases: 'No Purchases',
    product: 'Product',
    provider: 'Provider',
    unitaryPrice: 'Unitary Price',
    destination: 'Destination',
    amount: 'Amount',
    serial: 'Serial No.',
    status: 'Status',
    createdDate: 'Creation Date',
    totalPrice: 'Total Price',
    insertAnother: 'Insert Another',
    productOrIngredient: 'Product/Ingredient',
    newPurchase: 'New Purchase',
    addProductToList: 'Add product to list',
    addProduct: 'Add product',
    productType: 'Product type',
    purchaseList: 'Purchase list',
    purchasePrice: 'Purchase price',
    unit: 'unit',
    iva: 'IVA',
    total: 'Total',
    subtotal: 'Subtotal',
    noProvider: 'No Provider',
    totalPriceWithIVA: 'Total with IVA',
    generalInfo: 'General information',
    pay: 'Pay',
    payDate: 'Pay date',
    successPurchase: 'Purchase made successfully',
    successUpdatePurchase: 'Purchase updated successfully',
    payPurchase: 'Pay Purchase',
    selectPaymentMethod: 'Select payment method',
    date: 'Purchase date',
  },
  purchaseStatus: {
    pending: 'Pending',
    bought: 'Bought',
    paid: 'Paid',
  },
  purchaseOrder: {
    newPurchaseOrder: 'New Order',
    noPurchaseOrder: 'No Orders',
    date: 'Order date',
    status: 'Status',
    convertToPurchase: 'Convert',
    confirmConvert: 'You want to convert this order into a purchase?',
    successPurchaseOrder: 'Order placed successfully',
    successUpdatePurchaseOrder: 'Order edited successfully',
    sendMailTo: 'Do you want to send the order to',
    toEmail: 'with email',
    sendOrder: 'Send order',
    checkProviderEmail: 'The selected supplier does not have an assigned email',
  },
  printer: {
    noPrinters: 'No Printers',
    main: 'Main',
    mainPrinter: 'Main Printer',
    mainPrinterOf: 'Main printer of',
    mainPrinterMenu: 'The primary printer prints the customer ticket (the account). There can only be one main printer per POS.',
    secondaryPrinterOf: 'Secondary printer of',
    secondaryPrinterMenu: 'The secondary printers are the kitchen printers, the ones that print the kitchen receipts.',
    printerCategoriesMenu: 'Assign the categories you want to be printed by this printer.',
    printerZonesMenu: 'Assign the zones you want to be printed by this printer.',
    printerFamiliesMenu: 'Use this option only if you want this printer to pull multiple tickets into each order depending on the family it has. This option requires the Print by Family option to be enabled in Settings>Ticket.',
    name: 'Name',
    categories: 'Categories',
    allowToMarch: 'Allow to March',
    printInvoice: 'Print invoice',
    width: 'Width',
  },
  reports: {
    selectReport: 'Select Report',
    locales: 'Locales',
    actionNotAllowed: 'You must authenticate at the selected location to perform this action',
    views: {
      dash: 'Dashboard',
      sales: 'Sales',
      expenses: 'Expenses',
      reportsInfo: 'Informations',
      predictions: 'Predictions',
    },
    payment_types: {
      credit_card: 'Credit Card',
      cash: 'Cash',
      split: 'Split',
      split_product: 'Split by products',
      split_price: 'Split by price',
      transfer: 'Transfer',
    },
    types: {
      sales: 'Sales',
      products: 'Products',
      requestHistory: 'Requests History',
      stock: 'Stock',
      purchases: 'Purchases',
      apriori: 'Apriori',
      associations: 'Associations',
      probability: 'Probability',
      economicSubscriptions: 'Economic Subscriptions',
    },
    requestNo: 'Request N°.',
    totalLast30Days: 'Total in last 30 days',
    totalSinceLastCashRegister: 'Total since last cash register',
    middleTime: 'Middle time',
    box: {
      lastCashRegister: 'Last Cash Register',
      serialNo: 'Serial N°.',
      from: 'From',
      to: 'To',
      totalCard: 'Total Card',
      totalCash: 'Total Cash',
      total: 'Total',
      noCashRegisters: 'No Cash Registers',
      register: 'Register Cash',
      generating: 'Generating Cash Register',
      closeShiftDetails: 'Close Shift Details',
      closeBoxDetails: 'Cash Register Details',
      types: 'Types',
      wCard: 'With Card',
      wCash: 'With Cash',
      totalIncome: 'Total Income',
      initialAmount: 'Initial Amount',
      totalAmount: 'Total Amount',
      cashRegister: 'Cash Register',
      insertCoinAndBill: 'Insert Bill and Coin Amount',
      closeWithoutRegister: 'Close without register',
      totalDiscounted: 'Total Discount',
      totalWithDiscount: 'Total with Discount',
      unbalance: 'Unbalance',
      closingCarriedOutBy: 'Closing carried out by',
      taxes: 'Taxes',
      totalEconomicSubscription: 'Total economic subscription',
      totalTips: 'Total Tips',
      totalExpenses: 'Total Expenses',
      totalExpensesCash: 'Total Expenses Cash',
      totalExpensesCard: 'Total Expenses Card',
      pickupCash: 'Pickup Cash',
      pickupCard: 'Pickup Card',
      pickupTotal: 'Total Pickup',
      domicileCash: 'Domicile Cash',
      domicileCard: 'Domicile Card',
      domicileTotal: 'Total Domicile',
      barCash: 'Bar Cash',
      barCard: 'Bar Card',
      barTotal: 'Total Bar',
      localCash: 'Local Cash',
      localCard: 'Local Card',
      localTotal: 'Total Local',
      globalTotal: 'Total Global',
      totalByRequestType: 'Totals by request type',
      resume: 'Resume',
      closeType: 'Close Type',
      closeBox: 'Close Box',
      closeShift: 'Close Shift',
      totalCardBank: 'Total card in bank',
      cardUnbalance: 'Card unbalance',
      changeShift: 'Change shift',
      totalCashBox: 'Total cash in box',
      arqueo: 'Arching',
      newClose: '+New close',
      salesResume: 'Sales resume',
      expenseResume: 'Expenses resume',
      totalCashInBox: 'Total cash in box',
      totalSales: 'Total sales',
      totalBase: 'Base total',
      close_box: 'Box close',
      close_shift: 'Shift close',
    },
    products: {
      filters: 'Filters',
      serialNo: 'Serial N°.',
      name: 'Name',
      price: 'Price',
      frequencyInRequests: 'Frequency in requests',
      sales: 'Sales',
      total: 'Total',
      requestsType: 'Requests Type',
      from: 'From',
      to: 'To',
      noResults: 'No Results',
      last30Days: 'Most selled last 30 days',
    },
    stocks: {
      filters: 'Filters',
      serialNo: 'Serial No.',
      productName: 'Name',
      name: 'Name',
      stockName: 'Stock Name',
      qty: 'Amount',
      price: 'Price',
      total: 'Total',
      from: 'From',
      discount: 'Discount',
      motive: 'Description',
      type: 'Type',
      to: 'To',
      operator: 'Operator',
      noResults: 'No Results',
      showStock: 'Show Stock',
      measures: 'Measures',
      amountToUpdate: 'Amount to update',
      updateStock: 'Update stock',
      willAdd: 'Will be added',
      willDiscount: 'Will be discounted',
      unitsToStock: 'unit/s to the warehouse',
      unitsFromStock: 'unit/s from the warehouse',
    },
    requestsHistory: {
      filters: 'Filters',
      noResults: 'No Results',
      previewRequest: 'Preview Request',
      serialNo: 'Serial No.',
      table: 'Table',
      creditCard: 'Credit Card',
      dateOfCreation: 'Date of Creation',
      price: 'Price',
      type: 'Type',
      from: 'From',
      to: 'To',
      status: 'Status',
    },
    sales: {
      filters: 'Filters',
      noResults: 'No Results',
      previewTable: 'Preview Table',
      previewRequest: 'Preview Request',
      serialNo: 'Serial No.',
      table: 'Table',
      creditCard: 'Credit Card',
      dateOfCreation: 'Date of Creation',
      closeDate: 'Close Date',
      dateRange: 'Date Range',
      price: 'Price',
      type: 'Type',
      status: 'Status',
      from: 'From',
      to: 'To',
      exportToExcel: 'Export To Excel',
      payment: 'Payment Type',
      date: 'Date',
      min: 'Min',
      max: 'Max',
      average: 'Average',
      estSales: 'Sales estimated(ud)',
      estTotal: 'Total estimated',
      antecedent: 'Antecedent',
      consequent: 'Consequent',
      antecedents_support: 'Antecedent Support',
      consequent_support: 'Consequent Support',
      payedBy: 'Payed by',
      requestedBy: 'requested by',
      tips: 'Tips',
      paymentMethod: 'Payment method',
      changePaymentMethod: 'Change payment method',
      editPayment: 'Edit payment',
      paidBySplit: 'Paid by split',
      paid: 'Paid',
      dateAndHour: 'Date and hour',
      amount: 'Amount',
      paymentPlatform: 'Payment platform',
      notFoodeoPayment: 'The order was not paid with foodeo',
      paidSplitedByProducts: 'The order was paid by separating payments for products',
      paidSplitedByPrices: 'The order was paid by separating payments by price',
      closeBoxFinished: 'The cash closure has already been carried out on this order',
      invoiceUrl: 'Invoice URL',
      invoiceType: 'Invoice Type',
      invoiceVerifactuText: 'Verifiable invoice at the AEAT electronic headquarters',
      saleDetail: 'Sale detail',
      saleInfo: 'Sale info',
      requestInfo: 'Request information',
      seeInvoice: 'Go to invoice',
      paymentEdited: 'Payment type edited successfully',
      invoiceStatus: {
        pending: 'Pending',
        registered: 'Registered',
        stored: 'Stored',
        requires_correction: 'Requires correction',
        requires_inspection: 'Requires inspection',
        invalid: 'Invalid',
      },
    },
    probability: {
      name: 'Name',
      qty: 'Quantity',
      probability: 'Probability',
      jointProbability: 'Joint Probability',
      product1: 'Product 1',
      product2: 'Product 2',
    },
    apriori: {
      antecedent: 'Antecedent',
      consequent: 'Consequent',
      antecedents_support: 'Antecedents Support',
      consequent_support: 'Consequent Support',
      support: 'Support',
      confidence: 'Confidence',
      lift: 'Lift',
      max_len: 'Max Length',
      jointProbability: 'Joint Probability',
      product1: 'Product 1',
      product2: 'Product 2',
    },
    economicSubscription: {
      createdDate: 'Creation Date',
      serial: 'Serial No.',
      amount: 'Amount to be credited',
      noEconomicSubscriptions: 'No Economic Subscriptions',
      commandSerial: 'Command Serial No.',
      description: 'Description',
      creditCard: 'CreditCard',
      positiveCredit: 'Will be applied a positive credit of',
      negativeCredit: 'Will be applied a negative credit of',
    },
    expenses: {
      expenses: 'Expenses',
      amount: 'Amount',
      payedWith: 'Payed with',
      paymentMethod: 'Payment method',
      noExpenses: 'No Expenses',
      employee: 'Employee',
      alreadyPaid: 'Already close',
      status: 'Status',
      onlyNumbers: 'Only numbers',
    },
    dashboard: {
      salesSummary: 'Sales Summary',
      averageSummary: 'Average Ticket',
      hourlyBillingSummary: 'Orders by hours',
      pickDay: 'Pick a day',
      date: 'Date',
      last30Days: 'Last 30 days',
      totalSinceLastCashRegister: 'Since last cash register',
      currentMonth: 'Current month'
    },
    widgets: {
      requestNo: 'Request number',
      middleTime: 'Middle time',
      sales: 'Sales',
      expenses: 'Expenses',
      benefits: 'Benefits',
      cardSales: 'Card Sales',
      cashSales: 'Cash Sales',
      pendingSales: 'Sales pending to close',
      productsMostSelled: 'Most selled',
    },
    invoices: {
      invoices: 'Invoices',
      invoice: 'Invoice',
      showInvoices: 'Show invoices',
      noInvoices: 'No Invoices',
      date: 'Invoice date',
      invoiceNo: 'N°',
      total: 'Total',
      downloadFile: 'Download',
      concept: 'Concept',
      price: 'Price',
      units: 'Units',
      client: 'Client',
      dueDate: 'Due date',
      notes: 'Notes',
      subtotal: 'Subtotal',
      year: 'Year',
      all: 'All',
    },
    consumptionsReport: {
      consumptions: 'Consumptions',
      noConsumptions: 'No consumptions',
      serial: 'N° Serie',
      name: 'Name',
      type: 'Request type',
      qty: 'Quantity',
      unit: 'Unit',
      productOrIngredient: 'Product or ingredient',
      productType: 'Type',
      value: 'Value',
    },
    reportsInfo: {
      salesByMonth: 'Sales by month',
      salesByDay: 'Sales by day',
      salesByProducts: 'Sales by products',
      salesByCategories: 'Sales by categories',
      salesByRequestTypes: 'Sales by request types',
      salesByClients: 'Sales by clients',
      salesByEmployees: 'Sales by employees',
      salesByPaymentMethods: 'Sales by payment methods',
      salesByLocales: 'Sales by locales',
      expensesByMonth: 'Expenses by month',
      expensesByDay: 'Expenses by day',
      expensesByDate: 'Expenses by date',
      expensesByPaymentType: 'Expenses by payment type',
      expensesByEmployees: 'Expenses by employees',
      expensesByLocales: 'Expenses by locales',
      reportInfoTypes: 'Information types',
      salesByDate: 'Sales by date',
      filterType: 'Filter type',
      discountsByDate: 'Discounts by date',
      discountsByMonth: 'Discounts by month',
      discountsByDay: 'Discounts by day',
      tipsByDate: 'Tips by date',
      tipsByMonth: 'Tips by month',
      tipsByDay: 'Tips by day',
      date: 'Date',
      month: 'Month',
      total: 'Total',
      day: 'Day',
      requestType: 'Request type',
      paymentMethods: 'Payment methods',
      paymentMethod: 'Payment method',
      paymentType: 'Payment type',
      local: 'Local',
      barra: 'Bar',
      recoger: 'Pickup',
      domicilio: 'Delivery',
      salesByDayDownloadNamefile: 'Sales_by_days',
      salesByMonthDownloadNamefile: 'Sales_by_month',
      expensesByDayDownloadNamefile: 'Expenses_by_days',
      expensesByMonthDownloadNamefile: 'Expenses_by_month',
      discountsByDayDownloadNamefile: 'Discounts_by_days',
      discountsByMonthDownloadNamefile: 'Discounts_by_month',
      tipsByDayDownloadNamefile: 'Tips_by_days',
      tipsByMonthDownloadNamefile: 'Tips_by_month',
      expensesByEmployeeDownloadNamefile: 'Expenses_by_employees',
      salesByProductsDownloadNamefile: 'Sales_by_products',
      salesByCategoriesDownloadNamefile: 'Sales_by_categories',
      salesByRequestTypeDownloadNamefile: 'Sales_by_request_types',
      salesByClientsDownloadNamefile: 'Sales_by_clients',
      salesByEmployeesDownloadNamefile: 'Sales_by_employees',
      salesByPaymentMethodsDownloadNamefile: 'Sales_by_payment_methods',
      salesByLocalesDownloadNamefile: 'Sales_by_locales',
      expensesByPaymentTypeDownloadNamefile: 'Expenses_by_payment_type',
      expensesByLocalesDownloadNamefile: 'Expenses_by_locales',
    },
  },
  request: {
    closedSuccessfully: 'Request closed successfully',
    legend: 'Legend',
    requests: 'Requests',
    domiciles: 'Domicile',
    tables: 'Tables',
    cashier: 'Cashier',
    newRequest: 'New',
    bar: 'Bar',
    various: 'Various',
    maximize: 'Maximize',
    closeCash: 'Close Cash',
    closeCard: 'Close Card',
    closeCashLong: 'Close Cash',
    closeCardLong: 'Close Card',
    closeWithoutPayment: 'Close Table',
    productsToTable: 'Products to Table',
    editTable: 'Edit Table',
    observations: 'Observations',
    productObservations: 'Product Observations',
    addCombined: 'Add Combined',
    noAssociatedProducts: 'No Associated Products',
    noAggregatedProducts: 'No Aggregated Products',
    aggregated: 'Aggregated',
    name: 'Name',
    settings: 'Settings',
    type: 'Type',
    print: 'Print',
    price: 'Price',
    amount: 'Amount',
    total: 'Total',
    date: 'Date',
    requestDate: 'Request date',
    deliveryDate: 'Delivery date',
    pickupDate: 'Pickup date',
    invalidatedBy: 'Invalidated By',
    discount: 'Discount',
    discountType: 'Discount Type',
    originalPrice: 'Original Price',
    finalPrice: 'Final Price',
    percent: 'Percent',
    numeric: 'Numeric',
    with: 'with',
    applyDiscountToAll: 'Apply discount to the entire order',
    AddProductsOutsideTheMenu: 'Add products outside the menu',
    orderTimeDelay: 'How long will the order take?',
    customOrderTimeDelay: 'Personalized',
    productOutOfStock: 'Product out of stock',
    requestsTypes: {
      pickUp: 'To Pick Up',
      bar: 'Bar',
      domicile: 'Domicile',
      local: 'Local',
      all: 'All',
    },
    requestStatus: {
      all: 'All',
      payed: 'Payed',
      finished: 'Finish',
      invalidated: 'Invalidated',
      required: 'Required',
    },
    requestCardStatus: {
      solicited: 'Solicited',
      inProcess: 'Processing',
      toServe: 'To serve',
      received: 'Received',
      readyForPickup: 'Ready for pickup',
      onTheWay: 'On the way',
    },
    domicile: {
      serialNo: 'Serial number',
      software: 'Software',
      dealer: 'Dealer',
      noDealer: 'No delaer',
      searchDealer: 'Search dealer',
      status: 'Status',
      soon: 'As soon as possible',
      deliveryTime: 'Delivery time',
      pickupTime: 'Pickup time',
      noAllowShifts: 'There are no appointments available',
      origin: 'Origin',
    },
    overview: {
      noMarked: 'Pending',
      marked: 'Crossed out',
      overview: 'Overview',
    },
    rejectRequestTitle: 'Do you want to REJECT the request?',
    rejectRequestDescription: 'This is an irreversible action, if you reject the request, it will remain in an "Invalid" status, and the client will receive an email notifying that you reject it.',
    closeRequestTitle: 'Do you want to CLOSE the request?',
    closeRequestDescription: 'This action is irreversible, if you close the order you will not be able to recover it.',
    orderRequestsLabel: 'Order by',
    orderRequestsOptions: {
      creationDate: 'Creation date',
      deliveryDate: 'Delivery date',
    },
    deliveryRequestsRangeLabel: 'Show delivery requests',
    deliveryRequestsRangeOptions: {
      all: 'All',
      lessOneHour: 'Less than 1 hour',
      today: 'Today',
      tomorrow: 'Tomorrow',
      yesterday: 'Yesterday',
    },
    searchProduct: 'Search product',
    maxAggregates: 'Select max',
  },
  requestTable: {
    serialNo: 'Serial No.',
    type: 'Type',
    name: 'Name',
    total: 'Total',
    table: 'Table',
    date: 'Date',
    price: 'Price',
    introduceReceivedAmount: 'Introduce the Received amount',
    totalToPay: 'Total to Pay',
    received: 'Received',
    amount: 'Amount',
    toReturn: 'To Return',
    toPay: 'To Pay',
    closeCash: 'Close Cash',
    closeCard: 'Close Card',
    cashier: 'Cashier',
    print: 'Print',
    change: 'Change',
    split: 'Split',
    settings: 'Settings',
    payed: 'Payed',
    restorePayments: 'Restore Payments',
    finalizedPayments: 'Finalized Payments',
    amountToPay: 'Amount to Pay',
    various: 'Various',
    accountOptions: 'Account Options',
    selectWaiter: 'Select Waiter',
    invoice: 'Invoice',
    actualizedContent: 'Actualized Content',
    nonValidTable: 'This products are not valid, the table has been',
    actualized: 'Actualized',
    closed: 'Closed',
    splitByPrice: 'Split request by price',
    splitPrice: 'Split by price',
    splitProduct: 'Split by products',
    noProductsToPay: 'No products to pay',
    noPayedProducts: 'No payed products',
    payedProducts: 'Payed Products',
    payCard: 'Pay with card',
    payCash: 'Pay with cash',
    paymentDone: 'Payment Done!',
    paymentPending: 'Payment Pending',
    pendingReturn: 'Pending return',
    subTotal: 'Subtotal',
    commandId: 'Command ID',
    command_guests: 'Clients',
    details: 'Note',
    invalidAmount: 'Invalid amount',
    moreOptions: 'More options',
    toAddComment: 'To add comments, tap the product name',
    card: 'Card',
    cash: 'Cash',
    workingAs: 'Working as',
  },
  requestTableStatus: {
    available: 'Available',
    busy: 'Busy',
    pendingPay: 'Pending Pay',
    blocked: 'Blocked, waiting payment',
  },
  shift: {
    noShifts: 'No Shifts',
    from: 'From',
    to: 'To',
    capacity: 'Capacity',
    clientPerShift: 'Number of clients per shift',
    closedDays: 'Closed Days',
  },
  option: {
    noOptions: 'No options',
    title: 'Title',
    description: 'Description',
    clientSelectableAnswers: 'Client Selectable Answers',
    answers: {
      title: 'Title',
      description: 'Description',
    },
  },
  booking: {
    today: 'Today',
    left: 'Left',
    day: 'Day',
    month: 'Month',
    week: 'Week',
    diners: 'Diners',
    client: 'Client',
    options: 'Options',
    answer: 'Answer',
    addBooking: 'Add Booking',
    reserve: 'Reserve',
    ability: 'Available capacity',
    reservationDate: '{month} {day} from {start} to {end}',
    notAllowedCapacity: 'Capacity not allowed',
    turn: 'Turn',
    command_guests: 'Guests',
    name: 'Name',
    phone: 'Phone',
    table: 'Table',
    observations: 'Observations',
    actions: 'Actions',
    edit: 'Edit',
    all: 'All',
    date: 'Date',
    noTurns: 'No reservations today',
  },
  payment: {
    types: {
      cash: 'Cash',
      creditCard: 'Credit Card',
      both: 'Both',
    },
    dojo: {
      tableBeingPayed: 'Wait... the table is being payed',
      requestBeingPayed: 'Wait... the request is being payed',
      successfulPayment: 'The table was successfully payed',
      errorPayment: 'Timeout, check your payment manually or retry',
      declinedCard: 'Your credit card was declined',
      operationCancelled: 'The operation was cancelled',
      operationCancelling: 'Cancelling...',
      signVerification: 'Sign verification in progress',
      confirm: 'Confirm',
      timeout: 'Confirm in the device if the transaction complete successfully',
      unavailable: 'The device is unavailable, please, try again in 10 seconds, check PDQ screen or restart the PDQ. If the problem persists contact with support',
      error: 'Error in dojo configuration, contact foodeo support',
      selectDataphone: 'Select dataphone',
      mustAddDataphone: 'Must add a dataphone',
    },
    cashmatic: {
      tableSuccessfulPayment: 'The table was paid correctly',
      requestSuccessfulPayment: 'The order was paid correctly',
      error: 'An error has occurred in the payment process, please try again or contact Foodeo',
      noCancelled: 'Payment could not be canceled',
      timeOut: 'Payment waiting time has expired. Please try to make your payment again. If the problem persists, contact Foodeo.',
      notDispensedAmount: 'Amount not dispensed',
    }
  },
  settings: {
    app: {
      app: 'APP',
      notifyText: 'Notification Text',
      localPayments: 'Local Payments',
      domicilePayments: 'Domicile Payments',
      pickUpPayments: 'Pick up Payments',
    },
    domicile_pickup: {
      domicile_pickup: 'Delivery',
      blockOrders: 'Block Orders',
      allowOrders: 'Allow Orders',
      closed: 'Closed',
      open: 'Open',
      schedules: 'Schedules',
      priceServiceDomicile: 'Domicile price',
      minimumAmountForDomicile: 'Minimum amount for domicile',
      autoAcceptDomicile: 'Accept home orders automatically',
      autoAcceptPickup: 'Accept pickup orders automatically',
      allowDelivery: 'Allow home delivery orders',
      allowPickup: 'Allow pickup orders',
      orderTimeDelay: 'Order delay time',
      addOrderTime: 'Add time',
      time: 'time',
      deleteTime: 'Delete time',
      noOrdersTime: 'No Times',
      noMoreOptions: 'No more than 3 options',
      alreadyExist: 'Already exist',
      shiftDuration: 'Shift duration',
      max2h: 'Max allowed 120min',
      minimumAdvanceDomicile: 'Minimum advance for delivery',
      minimumAdvancePickup: 'Minimum advance for pickup',
      maxProductsByTurn: 'Maximum number of products per shift',
      limitedCategories: 'Categorías limitadas',
      domicileOrdersLimit: 'Delivery orders limit',
      maxAddressesRange: 'Maximum distance for delivery orders',
      request_without_client_domicile: 'Allow requests without client domicile',
      request_without_client_pickup: 'Allow requests without client pickup',
    },
    global: {
      globals: 'Globals',
      globalSettings: 'Global Settings',
      iva: 'IVA',
      minStockAlert: 'Minimum stock reached alert',
      showCombinedAggregatedCategories: 'Show Combined/Aggregated Categories',
      localId: 'Local ID',
      newRequestSound: 'Play sound when new request arrives',
      printBy: 'Print by',
      useVibrant: 'Usar Vibrant',
      useKeyboard: 'Use Virtual Keyboard',
      selectUserBeforeOrder: 'Select employee before each order',
      useModifiers: 'Use Modifiers',
      usePaymentTerminal: 'Use payment terminal',
      useCashmatic: 'Use cashmatic',
      localAddress: 'Local Address',
      addressPlaceholder: 'Search an address...',
      getGeolocation: 'Use geolocation',
      addressWithoutCoordinates: 'You must select an address in the map, use the search to find it',
      closeBarOrderAuto: 'Close order automatically in bar',
      timeZone: 'Time Zone',
    },
    kitchenTicket: {
      kitchenTicket: 'Kitchen Ticket',
      showLocalHeadings: 'Show Headings in Local requests',
      showDomicileHeadings: 'Show Headings in Domicile/Pick Up requests',
      showUnitaryPrice: 'Show Unitary Price',
      showTotalPrice: 'Show Total Price',
      showCommandGuests: 'Show guests number',
      groupProductsByOrders: 'Group Products by Orders',
      sendNameInTicket: 'Send Waiters/Clients name in kitchen ticket',
      headingStyle: 'Heading Style',
      font: 'Font',
      size: 'Size',
      style: 'Style',
      productsStyle: 'ProductsStyle',
    },
    ticket: {
      ticket: 'Ticket',
      usePrinter: 'Use Printer',
      ticketInfo: 'Ticket Information',
      ticketHeading: 'Ticket Heading',
      phone: 'Phone Number',
      socialReason: 'Social Reason',
      nifCif: 'Nif / Cif',
      fullAddress: 'Full Address',
      amountOfClientTickets: 'Amount of Client Tickets',
      amountOfKitchenTickets: 'Amount of Kitchen Tickets',
      printKitchenTicketIn: 'Print Kitchen Ticket Automatically in',
      printClientTicketIn: 'Print Client Ticket Automatically in',
      domicilePickUpRequests: 'Domicile/PickUp Requests',
      localRequests: 'Local Requests',
      barRequests: 'Bar Requests',
      printOptions: 'Print Options',
      printBy: 'Print By',
      combinedPrintBehavior: 'Combined Print Behavior',
      aggregatedPrintBehavior: 'Aggregated Print Behavior',
      samePrinterAsContainerProduct: 'Same Printer as the container Product',
      categoryPrinter: 'Category Printer',
      main_printer: 'Main printer by TPV',
      use_main_printer: 'Use main printer by TPV',
      ticket_text: 'Ticket footer text',
      showPrintTicketClientInfo: 'Activate these options if you want a customer ticket (the account) to be printed automatically when you place any of the following types of orders.',
      showPrintTicketKitchenInfo: 'Activate these options if you want a kitchen receipt to be printed automatically when you place any of the following order types',
      printBeforeClose: 'Close request',
    },
    digitalMenu: {
      digitalMenu: 'Digital Menu',
      logo: 'Logo',
      headlineImage: 'Headline Image',
      title: 'Title',
      subtitle: 'Subtitle',
      description: 'Description',
      mainColor: 'Main color',
      backgroundColor: 'Background color',
      headlineBackgroundColor: 'Headline background color',
      minDomicileRequest: 'Minimum domicile request',
      allowTips: 'Allow tips',
      email: 'Email for legal notice',
      bookings: 'Bookings',
      call_waiter: 'Call Waiter',
      local_orders: 'Table Ordering',
      useAwards: 'Use Awards',
      showBookingsInfo: 'If you enable this option, it allows customers to make bookings from the digital menu.',
      showCallWaiterInfo: 'If you enable this option, an option is displayed in the menu to call the waiter, when a customer clicks on this option an alert will be displayed on the POS that the customer is requesting a waiter.',
      showLocalOrdersInfo: 'If enabled, this option allows customers to place orders from the QR code on the table.',
      showAllowTipsInfo: 'If you enable this option, an option will appear for customers to add tips when finalizing their order on the digital menu.',
      showUseAwardsInfo: 'If the option is activated, the Prizes option will appear on the digital menu.',
      confirmationMessageForKioskoInCash: 'Message for kiosko in cash',
      confirmationMessageForKioskoInCard: 'Message for kiosko in card',
      confirmationMessageForDigitalMenu: 'Message for digital menu',
      kioskHeadlineImage: 'Headline Image for kiosko',
    },
    booking: {
      booking: 'Bookings',
      minClients: 'Minimum clients per reservation',
      maxClients: 'Maximum clients per reservation',
      emailNotification: 'Notifications email ',
    },
    stock: {
      defaultStock: 'Default warehouse',
      showDefaultStockInfo: 'The default warehouse is the one that will be used to automatically discount products.'
    },
  },
  units: {
    name: 'Name',
    type: 'Type',
    noUnits: 'No units',
    value: 'Quantity',
    unit_reference: 'Reference unit',
    customeUnits: 'Custome units',
    measures: 'Measures',
    configUnits: 'Config measures',
    showCustomUnitsInfo: 'Custom measurement units in Foodeo help you manage your products and ingredients more efficiently. They allow you to purchase products in specific quantities. For example, you can create a unit called “Coca-Cola Box” to buy 24 units together. More info:<a href="https://academy.foodeo.es/es/articles/9864204-como-crear-unidades-de-medida-personalizadas" target="_blank">How to create custom measurement units | Help Center</a>',
  },
  stock: {
    name: 'Name',
    serial: 'Serial',
    description: 'Description',
    minReach: 'The Product amount is below the permitted by the configurations',
    serialNo: 'Serial No.',
    amount: 'Amount',
    amountToDiscount: 'Amount to discount',
    price: 'Price',
    category: 'Category',
    activated: 'Activated',
    allergens: 'Allergens',
    location: 'Location',
    noStocks: 'No Stocks',
    payment: 'Payment',
    cannotDeleteStock: 'You cant run out of warehouses',
    selectStock: 'Select a stock',
    history: 'Historial',
    modificationsHistory: 'Historial de modificaciones',
    date: 'Fecha',
  },
  modifier: {
    name: 'Name',
    appText: 'App-Text',
    description: 'Description',
    image: 'Image',
    min: 'Minimum',
    max: 'Maximum',
    minShort: 'Min',
    maxShort: 'Max',
    addModifier: 'Add Modifier',
    addOption: 'Add Option',
    searchOption: 'Search Opción',
    searchModifier: 'Search Modifier',
    options: 'Options',
    isQuantifiable: 'Is Quantifiable',
    isRequired: 'Is Required',
    addedPrice: 'Added Price',
    amount: 'Amount',
    chooseMinMax: 'Choose Min {0} and Max {1}',
    addProductsCategories: 'Add Products/Categories',
    noModifiers: 'Sin Modificadores',
    noOptions: 'The modifier has no options',
    lessOptionsThanMin: 'The modifier has less options than minimum required',
    moreThanMax: 'You\'ve selected more than max',
    lessThanMin: 'You\'ve selected less than min',
    amountToDiscount: 'Amount to discount from stock',
    mustBeMoreThanMinimum: 'Must be more or equal than minimum',
    mustBeLessThanMaximum: 'Must be less or equal than maximum',
    maxReached: 'Max reached',
    amountToSelect: 'Amount of modifiers to select',
    optionAmountToSelect: 'Amount of options to select',
  },
  videos: {
    productsSubtitle: 'From the Products page you can create the products on the menu. You can watch the following video for more information.',
    categoriesSubtitle: 'From the Categories page you can create the menu categories. You can watch the following video for more information.',
    tablesSubtitle: 'From the Tables page you can create the tables to be able to assign them to the Zones and thus compose the premises. You can watch the following video for more information.',
    zonesSubtitle: 'From the Zones page you can create the premises zones and assign the tables and the TPV. You can watch the following video for more information',
    screensSubtitle: 'From the Screens page you can create store screens and manage your orders. You can watch the following video for more information',
    awardsSubtitle: 'From the Rewards page you can create the rewards that customers can redeem with their points.',
    employeesSubtitle: 'From the Employees page you can create employees and assign them the corresponding role.',
    clientsSubtitle: 'From the Clients page you can see all the clients you have registered in the system.',
    printersSubtitle: 'From the Printers page you can configure the printers to print kitchen and customer tickets. You must assign the corresponding categories and zones to each printer. There can only be one main printer per POS. The rest must be assigned as secondary POS. You can watch the following video for more information.',
    cashiersSubtitle: 'From this page you can create the drawers and assign them to the printer. By default the pulse is usually 200 and the port is 0.',
    familiesSubtitle: 'From the Families page you can create families to group the categories, this way you can print separate tickets on the same printer. You can watch the following video for more information',
    boxReportSubtitle: 'From the Cash Closing page you can close the cash register or shift. It is not necessary to open a shift, the cash closing counts from the last cash closing carried out to the current closing. You can watch the following video for more information',
    shiftsSubtitle: 'Shifts are used to create reservations and assign them to shifts. Each shift will have a schedule and a maximum number of diners. In this way, when a reservation is created for a shift, the diners of the indicated shift will be automatically discounted. You must create as many shifts as the client has the possibility of creating a date.',
    bookingOptionsSubtitle: 'From the Options screen you can create different options for your reservations, for example you could create the terrace option and the indoor option, so that clients can choose the option they want.',
    bookingsSubtitle: 'From the Calendar screen you can see customer reservations, it is also possible to create a new reservation. You can change the view to day, week or month.',
    reportsSubtitle: `<p>From the Reports screen you have several options:</p>
    <p> <strong>DASHBOARD</strong>: We can see a series of widgets to see the billing for the last 30 days or since the last cash closing.</p>
    <p> <strong>VENTAS</strong>: We can see the sales made at the store and filter them by different options such as order type. By changing the report to Products you can see the best-selling products and filter by category.</p>
    <p> <strong>GASTOS</strong>: On the Expenses screen we can see the Expenses, Purchases and Credit Payments reports.</p>
    <ol type="i">
        <li>Gastos: Here you will see all the expenses you have made, how, by whom, and when you have made them. From this screen we can add an expense, for example if we make a purchase from a supplier.</li>
        <li>Abonos: Credits are used to add or deduct an amount to a table that is already closed, but before the cash register has been closed.</li>
        <li>Compras: Purchases show purchases that have been made from suppliers to stock up. It will only be operational if you have contracted the stock module.</li>
    </ol><p></p>
    <p> <strong>PREDICCIONES</strong>: From the Sales Predictions report we can see the estimated sales on a given date. From the Product Predictions report we can see the different products that are expected to be sold. From the Association Predictions report it is possible to see the probability that several products have been purchased together.</p>`,
    settingsSubtitle: 'From the Settings screen we can make different settings such as tickets, configure the design of the digital menu or establish reservation shifts.',
    stockReportSubtitle: 'From the Stock screen we can see all the products left in the warehouses and discount the quantities manually.',
    recipesSubtitle: 'On the Escandallos screen you can see all your products and know what the profit margin is for each dish. By clicking on the product you can see and modify the price of the product and the purchase price, if the product has ingredients to obtain the profit margin it will add the total of all the ingredients. You can also view the ingredients of each dish.',
    purchasesSubtitle: 'From the Purchases screen we can make purchases to compose the Stock.',
    stockSubtitle: 'From the Warehouses screen we can create the warehouses and then make purchases and store the products in the warehouses.',
    providerSubtitle: 'From the Suppliers screen we can create suppliers to assign each purchase to a supplier and have control of who we make purchases from.',
    ingredientsSubtitle: 'From the Ingredients screen we can create the ingredients of the products, to be able to assign these ingredients to the products. This way when we sell a product, the ingredients in the Stock will be discounted.',
    modifiersSubtitle: 'From the modifiers page in Foodeo, you can create and manage modifiers for your products. Specifically, you can: <br>&nbsp;&nbsp;&nbsp;&nbsp; 1. Create new modifiers by clicking the "+New" button<br>&nbsp;&nbsp;&nbsp;&nbsp; 2. Configure options for each modifier (such as types of croquettes, pizza extras, menu options, etc.)<br>&nbsp;&nbsp;&nbsp;&nbsp; 3. Set minimum and maximum quantities for each modifier<br>&nbsp;&nbsp;&nbsp;&nbsp; 4. Customize your menu with product variants without needing to create multiple individual products  \n' +
      'Modifiers are especially useful for products with different sizes or flavors, allowing you to simplify your menu while offering multiple options to your customers.<br>You can watch this video where we explain it in more detail:\n',

  },
  timeTracking: {
    noEmployees: 'No employees',
    enterPassword: 'Enter password',
    password: 'Password',
    access: 'Access',
    currentWorkSession: 'Current work session',
    enter: 'Enter',
    stop: 'Stop',
    thisWeek: 'This week',
    thisMonth: 'This month',
    wrongPassword: 'Wrong password',
    day: 'Date',
    timeRange: 'Time range',
    total: 'Total',
    from: 'From',
    to: 'To',
    forbiddenSessionEdit: 'You cannot edit another employee\'s session',
  }
};
